module.exports = __webpack_public_path__ + "img/rlnotice_header.1010bdae.png";